import { render, staticRenderFns } from "./DevolucaoHome.vue?vue&type=template&id=7b2b6961"
import script from "./DevolucaoHome.vue?vue&type=script&lang=js"
export * from "./DevolucaoHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports